import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectQueueActiveProfile,
    selectQueueActiveProfileDescription,
    selectQueueDescription,
} from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import { getActiveUntil } from 'flow/utils';

interface Props {
    queueKey: QueueKey;
}
const SupervisorQueueDescriptionInfo = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();

    const queueDescription = useAppSelector((state) =>
        selectQueueDescription(state, queueKey),
    );
    const activeProfile = useAppSelector((state) =>
        selectQueueActiveProfile(state, queueKey),
    );
    const profileDescription = useAppSelector((state) =>
        selectQueueActiveProfileDescription(state, queueKey),
    );
    const profileUntilUiFriendly = getActiveUntil(activeProfile, i18next);
    const openUntilDescription = profileDescription
        ? `${profileDescription || ''} ${profileUntilUiFriendly}`
        : profileUntilUiFriendly;

    return (
        <div className="flex max-w-full cursor-default flex-col justify-center overflow-hidden pe-2">
            <span className="truncate text-gray-800">{queueDescription}</span>
            <span className="truncate text-sm text-gray-500">
                {openUntilDescription}
            </span>
        </div>
    );
};

export default React.memo(SupervisorQueueDescriptionInfo);
